import { ContractsSubscribed, ContractsUnsubscribed } from "./futuresContracts.actions";
import { ReducerBase } from "common/reducer";
import initialState from "app/initialState";
import FuturesContractSubscription from "./futuresContractSubscription";

export class FuturesContractSubscriptionsReducer extends ReducerBase<FuturesContractSubscription[]> {
    constructor() {
        super();

        this.addHandler(ContractsSubscribed.EventName, this.handleSubscribe);
        this.addHandler(ContractsUnsubscribed.EventName, this.handleUnsubscribe);
    }

    handleSubscribe(state: FuturesContractSubscription[], event: ContractsSubscribed) {
        const existingSubscription = state.find(m => m.id === event.subscriptionId);
        if (existingSubscription == null) {
            return [...state, { id: event.subscriptionId, symbols: event.symbols }]
        }
        else {
            return state.map(m => m.id === event.subscriptionId 
                ? { ...m, symbols: event.symbols}
                : m);
        }
    }

    handleUnsubscribe(state: FuturesContractSubscription[], event: ContractsUnsubscribed) {
        return state.filter(m => m.id !== event.subscriptionId);
    }

    handleDefault(state: FuturesContractSubscription[] = initialState.futuresContractSubscriptions) {
        return state;
    }
}
